<div class="widget-card kpi-widget" [ngClass]="widthClass">
  <div class="widget-header">
    <div class="chart-title">
      <span class="title-text">{{ widgetTitle }}</span>
    </div>
    <gains-ellipsis-menu 
      *ngIf="menuItems.length > 0" 
      class="ellipsis-button" 
      [menuItems]="menuItems" 
      (changeEvent)="handleMenuAction($event)">
    </gains-ellipsis-menu>
  </div>
  <div class="kpi-metric-section">
    <div class="kpi-content">
      <span class="kpi-value">{{ value }}</span>
      <span class="kpi-label" *ngIf="unit">{{ unit }}</span>
    </div>
  </div>
</div>